// /bible/:id opens a Bible where the reader left it (their synced reading position), or at its first
// chapter.
import { createFileRoute, Link, Navigate } from "@tanstack/react-router";
import { Empty } from "../../../components/Empty";
import ui from "../../../components/ui.module.css";
import { useLibraryEntry } from "../../../data/catalogueSource";
import { useBibleIndex } from "../../../reader/bible";
import { usePosition } from "../../../reader/useMarks";
import { useCollection } from "../../../sync/react";

export const Route = createFileRoute("/_app/bible/$id")({ component: OpenBible });

function OpenBible() {
  const { id } = Route.useParams();
  const { data: entry, isPending, isError: missing } = useLibraryEntry(id);
  const { data: index, isError } = useBibleIndex(entry?.kind === "bible" && entry.available ? entry : null);
  const positions = useCollection("readingPosition");
  const place = usePosition(id);

  if (missing || (!isPending && (!entry || entry.kind !== "bible")))
    return (
      <div className={ui.page}>
        <Empty title="This Bible isn’t in the library.">
          <Link to="/library" className={ui.secondary}>
            Library
          </Link>
        </Empty>
      </div>
    );
  // Unavailable or unreadable: the chapter page explains why.
  if (entry && (!entry.available || isError)) return <Navigate to="/bible/$id/$book/$chapter" params={{ id, book: "Gen", chapter: "1" }} replace />;
  if (!index || positions.isPending) return <div className={ui.page} aria-busy="true" aria-label="Opening the Bible" />;

  const m = /^(.+)\.(\d+)\.\d+$/.exec(place?.anchor?.verseKey ?? "");
  const at = m && index.books.find((b) => b.key === m[1] && b.chapters.includes(Number(m[2])));
  const first = index.books.find((b) => b.chapters.length > 0);
  const book = at ? m![1]! : (first?.key ?? "Gen");
  const chapter = at ? m![2]! : String(first?.chapters[0] ?? 1);
  return <Navigate to="/bible/$id/$book/$chapter" params={{ id, book, chapter }} replace />;
}
